// Descobre o índice do Datajud (CNJ) pelo número do processo e monta a URL da consulta.
// Número CNJ: NNNNNNN-DD.AAAA.J.TR.OOOO -> J = segmento da Justiça, TR = tribunal.

const TJ_BY_TR: Record<string, string> = {
  '01': 'tjac', '02': 'tjal', '03': 'tjap', '04': 'tjam', '05': 'tjba', '06': 'tjce', '07': 'tjdft',
  '08': 'tjes', '09': 'tjgo', '10': 'tjma', '11': 'tjmt', '12': 'tjms', '13': 'tjmg', '14': 'tjpa',
  '15': 'tjpb', '16': 'tjpr', '17': 'tjpe', '18': 'tjpi', '19': 'tjrj', '20': 'tjrn', '21': 'tjrs',
  '22': 'tjro', '23': 'tjrr', '24': 'tjsc', '25': 'tjse', '26': 'tjsp', '27': 'tjto',
};

const UF_BY_TR: Record<string, string> = {
  '01': 'ac', '02': 'al', '03': 'ap', '04': 'am', '05': 'ba', '06': 'ce', '07': 'dft', '08': 'es',
  '09': 'go', '10': 'ma', '11': 'mt', '12': 'ms', '13': 'mg', '14': 'pa', '15': 'pb', '16': 'pr',
  '17': 'pe', '18': 'pi', '19': 'rj', '20': 'rn', '21': 'rs', '22': 'ro', '23': 'rr', '24': 'sc',
  '25': 'se', '26': 'sp', '27': 'to',
};

/** Ex.: "0069563-39.2026.8.17.2001" -> "tjpe"; "0016890-50.2026.4.05.8302" -> "trf5" */
export function getDatajudAlias(processNumber: string): string | null {
  const digits = String(processNumber || '').replace(/\D/g, '');
  if (digits.length !== 20) return null;
  const segment = digits.charAt(13);
  const tr = digits.substring(14, 16);
  switch (segment) {
    case '8': return TJ_BY_TR[tr] || null; // Justiça Estadual
    case '4': return `trf${Number(tr)}`; // Justiça Federal
    case '5': return `trt${Number(tr)}`; // Justiça do Trabalho
    case '6': return UF_BY_TR[tr] ? `tre-${UF_BY_TR[tr]}` : null; // Justiça Eleitoral
    case '3': return 'stj';
    case '9': return tr === '13' ? 'tjmmg' : tr === '21' ? 'tjmrs' : tr === '26' ? 'tjmsp' : null; // Militar estadual
    default: return null;
  }
}

/** URL da consulta pelo proxy do site (rota de arquivo único, que funciona na Vercel) */
export function datajudSearchUrl(alias: string, query: string): string {
  const params = new URLSearchParams({ path: `api_publica_${alias}/_search`, q: query });
  return `/api/datajud-proxy?${params}`;
}
